export function roundNumber(value: number) {
  return Math.round(value * 100) / 100;
}
